module.exports = __webpack_public_path__ + "c.no1.094599fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/c.no1.jpg
// module id = tc2V
// module chunks = 0